module.exports = __webpack_public_path__ + "img/record-solid.48d8e738.svg";